import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, msalInstance } from './auth';
import { ThemeProvider } from 'next-themes';
import { TenantProvider } from './contexts/TenantContext';
import { ErrorState } from './components/ErrorState';
import { TabActivityIndicator } from './components/TabActivityIndicator';
import { queryClient } from './lib/queryClient';
import { adoptTenantFromOpenerTab, answerTenantQueries } from './lib/tenantStorage';
import App from './App';
import './index.css';

if (globalThis.self !== globalThis.top) {
  msalInstance.initialize().then(() => msalInstance.handleRedirectPromise()).catch(() => {});
} else {
  answerTenantQueries();
  const router = createBrowserRouter([
    {
      path: '*',
      errorElement: (
        <div className="p-8">
          <ErrorState
            title="Something went wrong"
            description="This page hit an unexpected error. Try again to reload it."
            testId="app-error"
            onRetry={() => globalThis.location.reload()}
          />
        </div>
      ),
      element: (
        <QueryClientProvider client={queryClient}>
          <ThemeProvider attribute="class" enableSystem defaultTheme="system">
            <AuthProvider>
              <TenantProvider>
                <TabActivityIndicator />
                <App />
              </TenantProvider>
            </AuthProvider>
          </ThemeProvider>
        </QueryClientProvider>
      ),
    },
  ]);

  adoptTenantFromOpenerTab().finally(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>
    );
  });
}
